export default __webpack_public_path__ + "static/about1-91ce2309c683668a2b356b00745885f0.png";